import { render, staticRenderFns } from "./IcoMagnifier.vue?vue&type=template&id=12df201e"
import script from "./IcoMagnifier.vue?vue&type=script&lang=js"
export * from "./IcoMagnifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports